var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRenameReadingListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_5004_2",
    "data-name": "Component 5004 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23293",
    "data-name": "Group 23293",
    transform: "translate(0 1.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23292",
    "data-name": "Group 23292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11286",
    "data-name": "Path 11286",
    d: "M13.072,40.957a.568.568,0,0,0-.568.568v5.683a.568.568,0,0,1-.568.568H1.705a.568.568,0,0,1-.568-.568V35.842a.568.568,0,0,1,.568-.568h6.82a.568.568,0,1,0,0-1.137H1.705A1.705,1.705,0,0,0,0,35.842V47.209a1.705,1.705,0,0,0,1.705,1.705h10.23a1.705,1.705,0,0,0,1.705-1.705V41.525A.568.568,0,0,0,13.072,40.957Z",
    transform: "translate(0 -34.137)",
    fill: "#676767"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23295",
    "data-name": "Group 23295",
    transform: "translate(3.41 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23294",
    "data-name": "Group 23294",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11287",
    "data-name": "Path 11287",
    d: "M114.275.641a2.175,2.175,0,0,0-3.077,0l-7.486,7.486a.575.575,0,0,0-.137.222l-1.137,3.41a.568.568,0,0,0,.539.748.577.577,0,0,0,.18-.029l3.41-1.137a.569.569,0,0,0,.222-.138l7.486-7.486A2.176,2.176,0,0,0,114.275.641Z",
    transform: "translate(-102.409 -0.004)",
    fill: "#676767"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameReadingListIcon);
export default __webpack_public_path__ + "static/media/rename-reading-list-icon.173e9e98b70e4eb7526f08f75688310e.svg";
export { ForwardRef as ReactComponent };